import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { Reparto } from '../../model'
import { AllocationRequest } from '../../requests/allocation.request'

export const apiRepartosGET = async (idCapacity: number): Promise<Reparto[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Allocations/ByCapacity/${idCapacity}`)
    .then(response => response.data)
}

export const apiRepartosPATCH = async ({ id, ...body }: AllocationRequest): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Allocations/${id}`, body).then(() => true)
}
